module.exports = __webpack_public_path__ + "static/media/10.a363fb43.jpg";